import { useContext } from 'react';

import { LoginContext } from './LoginProvider';
import { ModalContext } from './ModalProvider';
import { StorageContext } from './StorageProvider';
import { StoreContext } from './StoreProvider';
import { UIContext } from './UIProvider';
import { ShoppingCartContext } from './ShoppingCartProvider';
import { RecordLockHeartbeatContext } from './RecordLock/RecordLockHeartbeatContext';

export const useStore = () => useContext(StoreContext);
export const useLogin = () => useContext(LoginContext);
export const useStorage = () => useContext(StorageContext);
export const useModalContext = () => useContext(ModalContext);
export const useUISettings = () => useContext(UIContext);
export const useShoppingCart = () => useContext(ShoppingCartContext);
export const useRecordLockHeartbeat = () => useContext(RecordLockHeartbeatContext);
